// extracted by mini-css-extract-plugin
module.exports = {"root":"OptionsPopover_root__3AaKs","info":"OptionsPopover_info__34Bcc","btn":"OptionsPopover_btn__tV2G7"};